export default {
    name: "error404",
    components: {},
    data() {},
    async mounted() {
        this.$router.push("/acceso");
    },
    computed: {},
    methods: {}
};
